<template>
  <v-dialog v-model="open" max-width="480" persistent>
    <v-card class="voucher-benefit-modal">
      <div class="voucher-benefit-modal__hero">
        <div class="voucher-benefit-modal__glow" />
        <v-icon size="56" color="#FFD54F">mdi-ticket-percent</v-icon>
        <h2 class="voucher-benefit-modal__title">Parabéns!</h2>
        <p class="voucher-benefit-modal__subtitle">
          Você recebeu
          <strong>{{ quantity }}</strong>
          voucher{{ quantity === 1 ? "" : "s" }} Premium
          {{ target === "partner" ? "para parceiros" : "para associados" }}.
        </p>
      </div>
      <v-card-text class="text-center pb-2">
        <p class="mb-0 grey--text text--darken-1">
          {{
            target === "partner"
              ? "Use seus vouchers para transformar parceiros em Premium sem custo."
              : "Use seus vouchers para transformar associados em Premium sem custo e sem gerar comissões para a rede."
          }}
        </p>
      </v-card-text>
      <v-card-actions class="pa-4 pt-0">
        <v-spacer />
        <v-btn color="#e5183d" dark large rounded @click="handleClose">
          Entendi
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "VoucherBenefitModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    quantity: {
      type: Number,
      default: 0,
    },
    target: {
      type: String,
      default: "associate",
      validator: (value: string) => ["associate", "partner"].includes(value),
    },
  },
  computed: {
    open: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    handleClose() {
      this.$emit("dismiss");
      this.open = false;
    },
  },
});
</script>

<style scoped>
.voucher-benefit-modal {
  overflow: hidden;
  border-radius: 20px;
}
.voucher-benefit-modal__hero {
  position: relative;
  text-align: center;
  padding: 32px 24px 20px;
  background: linear-gradient(160deg, #1a1a2e 0%, #2d1b3d 45%, #e5183d 160%);
  color: #fff;
}
.voucher-benefit-modal__glow {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 50% 0%, rgba(255, 213, 79, 0.25), transparent 55%);
  pointer-events: none;
}
.voucher-benefit-modal__title {
  margin: 12px 0 8px;
  font-size: 1.6rem;
  font-weight: 800;
}
.voucher-benefit-modal__subtitle {
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
}
</style>
